import __request__ from "routing/request";
export function get(requestOptions) {
  return __request__("GET", "/system/outputs", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONbody, requestOptions) {
  return __request__("POST", "/system/outputs", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function available(requestOptions) {
  return __request__("GET", "/system/outputs/available", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getByoutputId(outputId, requestOptions) {
  return __request__("GET", `/system/outputs/${outputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(outputId, JSONbody, requestOptions) {
  return __request__("PUT", `/system/outputs/${outputId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(outputId, requestOptions) {
  return __request__("DELETE", `/system/outputs/${outputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
